import React, { useRef, useState, useEffect } from 'react';

import Navbar from "../../components/en/Navbar";
import Footer from "../../components/en/Footer";
import Cta from "../../components/en/CtaBranding";

import "../../styles/common.css";
import "../../styles/service.css";

import imgIssue01 from "../../img/branding/illustration_branding_01.svg";
import imgIssue02 from "../../img/branding/illustration_branding_02.svg";
import imgIssue03 from "../../img/branding/illustration_branding_03.svg";
import imgfeature01 from "../../img/branding/img_feature_01.png";
import imgfeature02 from "../../img/branding/img_feature_02.png";
import imgfeature03 from "../../img/branding/img_feature_03.png";
import imgfeature04 from "../../img/branding/img_feature_04.png";

import { works, resolveWork } from "../../data/works";
import { tagLabels } from "../../data/tagLabels";

const lang = "en";

const buildDisplayTags = (w) => {
  const industry = (w.industryTags ?? []).slice(0, 2);
  const companyCountry = w.company?.country ? [`companyCountry:${w.company.country}`] : [];
  return [...industry, ...companyCountry];
};

const Branding = () => {
  const resolvedWorks = works.map(resolveWork);
  
    const categories = ["Display", "Product", "Uniform", "Novelty", "SNS", "Character","Movie"];
    const brandingWorks = resolvedWorks
      .filter((w) => categories.includes(w.category))

  return (
    <>
      <Navbar></Navbar>
      <main className='branding'>
        <section className='fvUnder'>
          <div className='fvUnder-text'>
            <h1>Branding Support</h1>
            <nav aria-label="Breadcrumb" className="breadcrumb">
              <ol className='breadcrumb'>
                <li><a href="/en">Home</a></li>
                <li aria-current="page">Branding Support</li>
              </ol>
            </nav>
          </div>
        </section>
        <section className='issue'>
          <div className="title">
            <p className='title-lead'>ISSUE</p>
            <h2>We solve these issues</h2>
          </div>
          <div className='flexBox-bkWhite issue-box'>
            <div className='issue-box__item'>
              <div className='issue-item__image'>
                <img src={imgIssue01} alt="" />
              </div>
              <h3>We want to increase brand awareness in overseas markets, but don't know where to start</h3>
            </div>
            <div className='issue-box__item'>
              <div className='issue-item__image'>
                <img src={imgIssue02} alt="" />
              </div>
              <h3>We want to hold workshops to hear directly from customers for brand PR</h3>
            </div>
            <div className='issue-box__item'>
              <div className='issue-item__image'>
                <img src={imgIssue03} alt="" />
              </div>
              <h3>We want to use owned media and SNS to enhance long-term brand value</h3>
            </div>
          </div>
          <div className='issue-text'>
            <p>LOGOT supports<br className='sp-only' /><span>the future your company aims for</span><br /><span>through branding.</span></p>
          </div>
        </section>
        <section className='feature'>
          <div className="title">
            <p className='title-lead'>FEATURE</p>
            <h2>Four features of our branding support</h2>
          </div>
          <div className='feature-box flexBox-imgText'>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>01</span></p>
                <h3>Cross-border localization support | Strengthening the brand in overseas markets</h3>
                <p className='feature-item__detail'>We adapt the brand value to the overseas market in the best possible way, considering the different cultures, languages, and business environments of each market.<br />From the kickoff meeting, we thoroughly research the consumer needs and competitive situation of the target market.<br />Based on the results, we formulate translation, content localization, and PR strategies that resonate with the target audience.<br />We propose brand strategies that leverage cultural backgrounds and language characteristics to gain empathy in the local market, not just simple translations.</p>
              </div>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature01} alt="" />
              </div>
            </div>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature02} alt="" />
              </div>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>02</span></p>
                <h3>Create long-term brand value</h3>
                <p className='feature-item__detail'>A brand is not something that ends once it is created; continuous communication and nurturing are necessary.<br />LOGOT supports content branding using SNS and owned media based on brand strategy.<br />We plan branding strategies through posting content and images.</p>
              </div>
            </div>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>03</span></p>
                <h3>Create the "face" of the brand</h3>
                <p className='feature-item__detail'>The first impression of a brand is determined by its visual identity.<br />From the kickoff meeting, LOGOT delves deeply into the company's philosophy and target psychology, and proposes strategic logo designs, color palettes, and fonts based on market research.<br />We design visual expressions that differentiate from competitors and maximize the value of the brand, creating the "face" of the brand.</p>
              </div>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature03} alt="" />
              </div>
            </div>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature04} alt="" />
              </div>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>04</span></p>
                <h3>Provide a place to convey the brand value of the company</h3>
                <p className='feature-item__detail'>The value and message of a brand are deeply ingrained through experiences.<br />LOGOT helps shape the story of the brand that the company wants to convey into workshops and branding events.<br />We provide total production of planning, venue design, and operation tailored to the interests and behavioral characteristics of the target audience, based on market and competitor analysis.</p>
              </div>
            </div>
          </div>
        </section>
        <Cta></Cta>
        <section className='work-branding'>
          <div className='title'>
            <p className='title-lead'>WORK</p>
            <h2>Portfolio</h2>
          </div>
          <div className="work-box">
            {brandingWorks.map((w) => {
              const displayTags = buildDisplayTags(w);
          
              return (
                <article key={w.slug}>
                  <a href={`/en/work/${w.slug}`}>
                    <div className="work-box__image">
                      <img src={w.thumbnail} alt={w.title?.[lang] ?? ""} />
                    </div>
                    <div className="work-box__text">
                      <h3>{w.title?.[lang]}</h3>
          
                      {displayTags.length > 0 && (
                        <ul className="work-box__tag">
                          {displayTags.map((tag) => (
                            <li key={tag}>{tagLabels[tag]?.[lang] ?? tag}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </a>
                </article>
              );
            })}
          </div>
        </section>
        <section className='flow'>
          <div className="title">
            <p className='title-lead'>FLOW</p>
            <h2>Branding Support Process</h2>
          </div>
          <ol className='flow-box'>
            <li>
              <div className='flow-box__number'><p>1</p></div>
              <div className='flow-box__text'>
                <h3>Preparation and Hearing</h3>
                <p>Before starting the project, LOGOT conducts a detailed hearing of the vision, issues, and goals to maximize the brand value of the company.<br />We analyze the target market, competitive brands, and company strengths to prepare for determining the optimal branding measures.</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>2</p></div>
              <div className='flow-box__text'>
                <h3>Kickoff Meeting</h3>
                <p>Based on the hearing results, we clearly define the brand's worldview and design strategies for each measure to be implemented.<br />LOGOT decides the policy for each measure (design production, localization support, workshop holding) and proceeds according to the order content.</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>3</p></div>
              <div className='flow-box__text'>
                <h3>Implementation of measures to maximize brand value</h3>
                <p>In LOGOT's branding support, only the necessary measures can be implemented according to the company's objectives.<br />We can respond to requests such as "logo design only" or "workshop holding only".</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>4</p></div>
              <div className='flow-box__text'>
                <h3>Submission and Reporting</h3>
                <p>We share the final results and deliverables of the measures.<br />If necessary, we can also analyze the effects with data and report changes in brand awareness and engagement in the target market.</p>
              </div>
            </li>
          </ol>
        </section>
        <section className='qa'>
          <div className="title">
            <p className='title-lead'>Q&A</p>
            <h2>Frequently Asked Questions</h2>
          </div>
          <ul className='qa-box'>
            <li>
              <dl>
                <dt><p className='qa-box__q'>Q</p><p className='qa-box__text'>Is there a minimum contract period?</p></dt>
                <dd><p className='qa-box__a'>A</p><p className='qa-box__text'>We have a minimum contract period of "6 months" starting from the contract month.</p></dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt><p className='qa-box__q'>Q</p><p className='qa-box__text'>Is it possible to contract for a site created by another company?</p></dt>
                <dd><p className='qa-box__a'>A</p><p className='qa-box__text'>Yes, it is possible. However, if it is a site that our company has not been involved in building, some responses may be difficult due to unknown specifications and designs. Please understand this in advance.</p></dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt><p className='qa-box__q'>Q</p><p className='qa-box__text'>Please tell us the specific content of the branding support.</p></dt>
                <dd><p className='qa-box__a'>A</p><p className='qa-box__text'>Based on the issues heard in advance, we conduct multifaceted research including market analysis and access analysis, and propose "future brand operation policies" and "necessary measures and improvement plans".<br />In addition to strategy design for overseas markets, we also provide tactical level support that looks ahead to actual operations and implementation of measures, and support the improvement of brand value while working alongside customers.</p></dd>
              </dl>
            </li>
          </ul>
        </section>
        <Cta></Cta>
      </main >
      <Footer></Footer>
    </>
  );
};

export default Branding